import { combineReducers } from 'redux';

// Add your reducers below, and don't forget to add them in the combineReducers objects too!
import rootReducer from './root';

export default combineReducers({
  root: rootReducer,
});
